import { Button } from '../../../components/ui/button';
import { GiftsBlock, RsvpBlock, renderGalleryByPosition } from '../shared/TemplateBlocks';

const getLocationSummary = (site, locationCards) => {
  if (site.same_location && locationCards?.[0]) {
    return {
      ceremony: locationCards[0],
      reception: {
        title: 'Recepção',
        location: 'Mesmo local',
        address: locationCards[0].address || locationCards[0].location,
        time: site.reception_time || site.ceremony_time
      }
    };
  }

  return {
    ceremony: locationCards?.[0] || {
      title: 'Cerimônia',
      location: site.ceremony_location,
      address: site.ceremony_address,
      time: site.ceremony_time
    },
    reception: locationCards?.[1] || {
      title: 'Recepção',
      location: site.reception_location,
      address: site.reception_address,
      time: site.reception_time
    }
  };
};

export default function SerraNevoaTemplate(props) {
  const {
    site,
    theme,
    weddingDateLabel,
    daysUntil,
    locationCards,
    availableGifts,
    galleryPosition,
    isTemplatePreview,
    onTemplatePreviewRedirect,
    onOpenRsvp,
    onGiftClick,
    onOpenGallery,
    showCountdown,
    showGiftSection,
    showRsvpCount,
    confirmedGuests
  } = props;

  const primary = theme.primaryColor || '#4A5568';
  const secondary = theme.secondaryColor || '#718096';
  const soft = theme.bannerSectionBackground || '#EDF2F7';
  const page = theme.storySectionBackground || '#FAFAF8';
  const titleColor = theme.heroTitleColor || primary;
  const bodyColor = theme.bannerTextColor || theme.bodyTextColor || primary;
  const { ceremony, reception } = getLocationSummary(site, locationCards);

  const details = [
    {
      label: 'Cerimônia',
      value: ceremony?.location || ceremony?.title || 'Local da cerimônia',
      sub: [ceremony?.time, ceremony?.address].filter(Boolean).join(' · ')
    },
    {
      label: 'Recepção',
      value: reception?.location || reception?.title || 'Local da recepção',
      sub: [reception?.time, reception?.address].filter(Boolean).join(' · ')
    },
    {
      label: showRsvpCount ? 'Confirmados' : 'Contagem',
      value: showRsvpCount ? String(confirmedGuests || 0) + ' pessoa(s)' : String(daysUntil) + ' dias',
      sub: showRsvpCount ? 'Já confirmaram presença' : 'Até o grande dia'
    }
  ];

  const galleryNode = site.gallery_images?.length ? (
    <section style={{ background: theme.gallerySectionBackground || page }}>
      <div className="grid grid-cols-2 md:grid-cols-4">
        {site.gallery_images.slice(0, 8).map((img, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => onOpenGallery?.(idx)}
            className="group h-44 overflow-hidden md:h-72"
            aria-label={'Abrir foto ' + (idx + 1)}
          >
            <img
              src={img}
              alt={'Galeria ' + (idx + 1)}
              className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
            />
          </button>
        ))}
      </div>
    </section>
  ) : null;

  const openRsvp = () => (isTemplatePreview ? onTemplatePreviewRedirect?.() : onOpenRsvp?.());

  return (
    <>
      <section className="relative min-h-screen overflow-hidden px-6 py-20" style={{ background: 'linear-gradient(180deg, ' + primary + ', ' + secondary + ')' }}>
        <div className="mx-auto grid min-h-[78vh] max-w-6xl items-end gap-10 md:grid-cols-[1.2fr_0.8fr]">
          <div className="pb-10"><p className="mb-6 text-xs uppercase tracking-[0.46em]" style={{ color: soft }}>Serra & Névoa</p><h1 className="text-5xl italic leading-none md:text-7xl" style={{ color: soft, fontFamily: theme.bannerTitleFont || theme.headingFont }}>{site.couple_names}</h1><p className="mt-8 text-sm uppercase tracking-[0.22em]" style={{ color: soft, opacity: 0.72 }}>{weddingDateLabel}</p><Button
              onClick={openRsvp}
              className="mt-10 rounded-none px-10 uppercase tracking-[0.24em]"
              style={{
                background: theme.confirmButtonBackground || primary,
                color: theme.confirmButtonText || soft,
                borderColor: theme.confirmButtonBorder || primary,
                borderWidth: 1,
                borderStyle: 'solid'
              }}
            >
              Confirmar Presença
            </Button></div>
          <div className="min-h-[430px] overflow-hidden rounded-t-full border" style={{ borderColor: soft + '66' }}>{theme.heroImage ? <img src={theme.heroImage} alt={site.couple_names} className="h-full min-h-[430px] w-full object-cover" /> : null}</div>
        </div>
      </section>
      {renderGalleryByPosition(galleryPosition, 'after_hero', galleryNode)}
      <section className="px-6 py-20" style={{ background: page }}><div className="mx-auto max-w-4xl text-center"><h2 className="mb-6 text-4xl italic" style={{ color: theme.storyTitleColor || primary, fontFamily: theme.storyTitleFont || theme.headingFont }}>Nossa História</h2><p className="whitespace-pre-line leading-8" style={{ color: theme.storyBodyColor || bodyColor, fontFamily: theme.storyBodyFont }}>{site.story_text}</p></div></section>
      {renderGalleryByPosition(galleryPosition, 'after_story', galleryNode)}
      <section className="px-6 py-20 " style={{ background: theme.locationSectionBackground || primary }}>
        <h2
          className="mb-12 text-center text-3xl italic md:text-4xl"
          style={{ color: theme.locationTitleColor || soft, fontFamily: theme.locationTitleFont || theme.headingFont }}
        >
          O grande dia
        </h2>
        <div className="mx-auto grid max-w-5xl gap-px md:grid-cols-3" style={{ background: 'rgba(255,255,255,0.12)' }}>
          {details.map((item) => (
            <div key={item.label} className="p-8 text-center" style={{ background: theme.locationCardBackground || 'rgba(255,255,255,0.04)' }}>
              <p className="mb-4 text-[0.58rem] uppercase tracking-[0.4em]" style={{ color: theme.locationIconColor || secondary, fontFamily: theme.locationTextFont }}>{item.label}</p>
              <p className="mb-3 text-xl italic" style={{ color: theme.locationTitleColor || soft, fontFamily: theme.locationTitleFont || theme.headingFont }}>{item.value}</p>
              <p className="text-xs leading-6" style={{ color: theme.locationTextColor || 'rgba(255,255,255,0.62)', fontFamily: theme.locationTextFont }}>{item.sub}</p>
            </div>
          ))}
        </div>
      </section>
      {renderGalleryByPosition(galleryPosition, 'before_gifts', galleryNode)}

      <GiftsBlock
        gifts={availableGifts}
        headingFont={theme.headingFont}
        theme={theme}
        titleColor={primary}
        textColor={theme.bodyTextColor}
        secondaryColor={secondary}
        onGiftClick={onGiftClick}
        compact
        showGiftSection={showGiftSection}
      />

      {renderGalleryByPosition(galleryPosition, 'end', galleryNode)}

      <RsvpBlock
        onOpenRsvp={onOpenRsvp}
        isTemplatePreview={isTemplatePreview}
        onTemplatePreviewRedirect={onTemplatePreviewRedirect}
        primaryColor={primary}
        secondaryColor={secondary}
        sectionBackground={theme.rsvpSectionBackground || soft}
        buttonBackground={theme.confirmButtonBackground || primary}
        buttonText={theme.confirmButtonText || soft}
        buttonBorder={theme.confirmButtonBorder || primary}
        iconColor={theme.rsvpIconColor || secondary}
        titleColor={theme.rsvpTextColor || primary}
        bodyColor={theme.rsvpTextColor || bodyColor}
        countColor={theme.rsvpTextColor || bodyColor}
        headingFont={theme.rsvpTitleFont || theme.headingFont}
        bodyFont={theme.rsvpTextFont || theme.bannerTextFont}
        showRsvpCount={showRsvpCount}
        confirmedGuests={confirmedGuests}
      />

      <footer className="px-6 py-12 text-center" style={{ background: primary }}>
        <div className="text-3xl italic" style={{ color: soft, fontFamily: theme.headingFont }}>
          {site.couple_names}
        </div>
        <div className="mt-2 text-[0.65rem] uppercase tracking-[0.35em]" style={{ color: 'rgba(255,255,255,0.42)', fontFamily: theme.bannerTextFont }}>
          Virei Noiva
        </div>
      </footer>
    </>
  );
}

